import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import SectionHeader from 'commonComponents/Headers/SectionHeader/SectionHeader';
import styles from './Jobs.module.scss';
import './Jobs.scss';

const Jobs = ({ header, boxes }) => {
  return ( 
    <section className={ styles.Jobs } id="openPositions">
      <div className={ styles.content }>
        <SectionHeader
          title={ header }
          anchor='jobs'
          isPrime
        />
        <div className={ styles.jobTiles }>
          { ReactHtmlParser(boxes) }
        </div>
      </div>
    </section>
  );
};
 
export default Jobs;
